export const images = ["Images/nr2.jpg", "Images/nr1.jpg", "Images/nr3.jpg"];
